import { concat, defer, Observable, of } from 'rxjs';

export const startWithFactory =
  <T>(factory: () => T) =>
  (obs: Observable<T>): Observable<T> =>
    concat(
      defer(() => of(factory())),
      obs
    );
